<template>
    <div>
        <!-- <div class="search-box">
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
        </div> -->
        <div class="operation-box">
            <a-button 
                type="primary"
                icon="plus" 
                class="btn" 
                @click="add"
                v-if="permissions.indexOf('undergraduate:culture:nightCoaching:timeSet:add')>-1">
                 新增
            </a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="remove(selectedRowKeys[0])">
                <a-button
                    v-if="permissions.indexOf('undergraduate:culture:nightCoaching:timeSet:delete')>-1"
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    >
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit" 
                class="btn"
                v-if="permissions.indexOf('undergraduate:culture:nightCoaching:timeSet:edit')>-1"
                @click="edit()"
                >
                修改
            </a-button>
            <a-button 
                type="primary"
                icon="backward" 
                class="btn"
                @click="$router.go(-1)"
                >
                返回
            </a-button>
        </div>
        
        <a-table
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns"
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ y: '600px' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
        </a-table>

        <a-modal
            :title="modalTitle"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
            >
            <div class="info-box">
                <div class="info-main">
                    <div class="input-box">
                        <p>学年：</p>
                        <a-date-picker
                            class="input"
                            mode="year"
                            format='YYYY'
                            v-model="year" 
                            :open='yearShowOne' 
                            @openChange="openChangeOne"
                            @panelChange="panelChangeOne">
                            <a-input :disabled="type=='edit'" v-model="info.schoolYear" />
                            
                        </a-date-picker>
                    </div>
                    <div class="input-box">
                        <p>学期：</p>
                        <a-select class="input" :disabled="type=='edit'" allowClear v-model="info.semester" >
                            <!-- For years before 2025, keep all options -->
                            <template v-if="year < '2025'">
                                <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                                <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                                <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                            </template>
                            <!-- For 2025 and later, only show two semesters -->
                            <template v-else>
                                <a-select-option :value="year+'A'">秋季学期</a-select-option>
                                <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                            </template>
                        </a-select>
                    </div>
                    <div class="input-box">
                        <p>填报起始日期：</p>
                        <a-date-picker class="input" v-model="info.startDate" @change="onStartDateChange" />
                    </div>
                    <div class="input-box">
                        <p>填报截止日期：</p>
                        <a-date-picker @change="onEndDateChange" class="input" v-model="info.endDate" />
                    </div>
                    <div class="input-box">
                        <p>是否当前学期：</p>
                        <a-checkbox @change="onChange" v-model="info.current"></a-checkbox>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { timeSetList,timeSetAdd,timeSetEdit,timeSetDel } from '@/baseAPI/undergraduate/culture/nightCoaching'
    import { getSchoolYear,selectedCheck,transformSeason } from '@/baseAPI/util'

    export default {
        name: 'teacher',
        data () {
            return {
                columns:[
                    {
                        title: '序号',
                        align:'center',
                        width:50,
                        customRender: (text, row, index) => {
                            return { children: index+1};
                        },
                    },
                    {
                        title: '学期',
                        dataIndex: 'semester',
                        align:'center',
                        width:200,
                        customRender: (text, row, index) => {
                            return transformSeason(text)
                        },
                    },
                    {
                        title: '填报起始日期',
                        dataIndex: 'startDate',
                        align:'center',
                        width:120,
                        sorter: (a, b) => a.startDate.replace('-','').replace('-','') - b.startDate.replace('-','').replace('-','')
                    },
                    {
                        title: '填报截止日期',
                        dataIndex: 'endDate',
                        align:'center',
                        sorter: (a, b) => a.endDate.replace('-','').replace('-','') - b.endDate.replace('-','').replace('-',''),
                        width:120
                    },
                    {
                        title: '是否当前学期',
                        dataIndex: 'current',
                        align:'center',
                        width:100,
                        customRender: (text, row, index) => {
                            return <a-checkbox checked={text}></a-checkbox>
                        },
                    }
                ],
                visible: false,
                confirmLoading: false,
                data:[],
                loading: false,
                pagination:{
                    pageSizeOptions: ['10', '20', '30', '50', '100'],
                    showSizeChanger:true,
                    showTotal:total=>'共'+total+'条数据',
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    schoolYear:'',
                },
                type:'',
                xbArr:[],
                xxArr:[],
                kclbArr:[],
                permissions:[],
                year:'',
                yearShowOne:false,
                departmentTree:[],
                bkdyArr:[],
                bkdyqx:'',
                zcArr:[],
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'},
                info:{
                    id:"",
                    schoolYear: "",
                    semester: "",
                    startDate: "",
                    endDate: "",
                    current: null
                },
                modalTitle:''
            }
        },
        watch:{
            '$route':{
                handler(newVal,oldVal){
                    if(newVal.path === '/admin/undergraduate/assess'){
                        this.fetch()
                    }
                },
                deep:true,
                immediate:true
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'CAMPUS',status:true}).then(res=>{
                this.xxArr=res.data.dicts;
            })
            getDicts({dataCode:'KCLB',status:true}).then(res=>{
                this.kclbArr=res.data.dicts;
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
            })
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.departmentTree=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            onStartDateChange(date, dateString) {
                this.info.startDate=dateString
            },
            onEndDateChange(date, dateString) {
                this.info.endDate=dateString
            },
            add(){
                this.modalTitle="新增"
                this.type='add'
                this.info={}
                this.showModal()
            },
            edit(){
                this.modalTitle="编辑"
                this.type='edit'
                this.data.forEach(e=>{
                    if(e.id == this.selectedRowKeys[0]){
                        this.year=e.schoolYear.split('-')[0]
                        this.info=e
                        this.showModal()
                    }
                })
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.confirmLoading = true;
                if(!this.info['current']){
                    this.info['current']=false
                }
                if(this.type == 'edit'){
                    timeSetEdit(this.info).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'编辑成功',
                            });
                            this.visible = false;
                            this.confirmLoading = false;
                            this.fetch()
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        
                    })
                }else{
                    timeSetAdd(this.info).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'新增成功',
                            });
                            this.visible = false;
                            this.confirmLoading = false;
                            this.fetch()
                        }else{
                            this.confirmLoading = false;
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                        
                    })
                }
            },
            handleCancel(e) {
                console.log('Clicked cancel button');
                this.visible = false;
            },
            cancel(teacherId,schoolYear){
                cancel(teacherId,schoolYear).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'取消确认成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            selectedCheck(){
                selectedCheck()
            }, 
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize = pagination.pageSize;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                timeSetList(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                timeSetDel(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.info.schoolYear=this.year+'-'+(this.year-0+1);
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            }
        }
    }
</script>
<style scoped>

    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }

    .search-box-1
    {
        margin-bottom: 10px;
    }

    .search-box-1 p
    {
        display: inline-block;
    }
    .search-box-1 .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box-1 .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

    .info-box{
        margin-bottom: 1rem;
    }

    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1rem;
    }

    .info-main .input-box{
        width: 100%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }

    .info-main .input-box p{
        width: 8rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 8rem);
    }
</style>
